import React from 'react';
import { Link } from '@backstage/core-components';
import { makeStyles, Tooltip, IconButton, ListItem, ListItemText, Typography, ListItemSecondaryAction } from '@material-ui/core';
import { DateTime, Duration } from 'luxon';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import LinkIcon from '@material-ui/icons/Link';

const useStyles = makeStyles((theme) => ({
  denseListIcon: {
    marginRight: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  listItemPrimary: {
    fontWeight: "bold"
  },
  smallExternalLinkIconStyle: {
    color: theme.palette.text.primary
  },
  smallExternalLinkWithoutMarginIconStyle: {
    color: theme.palette.text.primary,
    marginRight: "-20px"
  },
  smallIconStyle: {
    color: theme.palette.text.primary,
    marginRight: "-20px"
  }
}));
const ChangeEventListItem = ({ changeEvent }) => {
  const classes = useStyles();
  const duration = (/* @__PURE__ */ new Date()).getTime() - new Date(changeEvent.timestamp).getTime();
  const changedAt = DateTime.local().minus(Duration.fromMillis(duration)).toRelative({ locale: "en" });
  let externalLinkElem;
  if (changeEvent.links.length > 0) {
    const text = changeEvent.links[0].text;
    externalLinkElem = /* @__PURE__ */ React.createElement(Tooltip, { title: text, placement: "top" }, /* @__PURE__ */ React.createElement(
      IconButton,
      {
        component: Link,
        to: changeEvent.links[0].href,
        className: changeEvent.html_url === void 0 ? classes.smallExternalLinkWithoutMarginIconStyle : classes.smallExternalLinkIconStyle
      },
      /* @__PURE__ */ React.createElement(LinkIcon, null)
    ));
  }
  return /* @__PURE__ */ React.createElement(ListItem, { dense: true, key: changeEvent.id }, /* @__PURE__ */ React.createElement(
    ListItemText,
    {
      primary: /* @__PURE__ */ React.createElement(React.Fragment, null, changeEvent.summary),
      primaryTypographyProps: {
        variant: "body1",
        className: classes.listItemPrimary
      },
      secondary: /* @__PURE__ */ React.createElement(Typography, { variant: "body2", color: "textSecondary" }, "Triggered from ", changeEvent.source, " ", changedAt, ".")
    }
  ), /* @__PURE__ */ React.createElement(ListItemSecondaryAction, null, externalLinkElem, changeEvent.html_url === void 0 ? null : /* @__PURE__ */ React.createElement(Tooltip, { title: "View in PagerDuty", placement: "top" }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      component: Link,
      to: changeEvent.html_url,
      className: classes.smallIconStyle
    },
    /* @__PURE__ */ React.createElement(OpenInBrowserIcon, null)
  ))));
};

export { ChangeEventListItem };
//# sourceMappingURL=ChangeEventListItem.esm.js.map
